/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_RightmoveInputs */

const cs_enum_rightmove = /** @type {(inputs: Enum_RightmoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rightmove`)
};

const en_enum_rightmove = /** @type {(inputs: Enum_RightmoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rightmove`)
};

/**
* | output |
* | --- |
* | "Rightmove" |
*
* @param {Enum_RightmoveInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_rightmove = /** @type {((inputs?: Enum_RightmoveInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_RightmoveInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_rightmove(inputs)
	return cs_enum_rightmove(inputs)
});